import React from "react"

// Per-app sync health. Mirrors the connection badge colour map (doc 04):
// syncing = amber, ready = green, error = red.
const CLASSES = {
  syncing: "bg-amber-50 dark:bg-amber-950/40 text-amber-700 dark:text-amber-300",
  ready: "bg-green-50 dark:bg-green-950/40 text-green-700 dark:text-green-300",
  error: "bg-red-50 dark:bg-red-950/40 text-red-700 dark:text-red-300",
}

export function SyncStatusBadge({ status, label }) {
  const cls = CLASSES[status] || "bg-gray-100 dark:bg-gray-800 text-gray-500 dark:text-gray-400"
  return (
    <span className={`inline-flex rounded-full px-2 py-0.5 text-xs font-medium ${cls}`}>
      {label}
    </span>
  )
}
